export default function passwordGenerate(max, min) {
  const passwordChars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz#@!%&()/';
  const randPwLen = Math.floor(Math.random() * (max - min + 1)) + min;
  const randPassword = Array(randPwLen).fill(passwordChars).map((x) => x[Math.floor(Math.random() * x.length)]).join('');
  return randPassword;
}
